import {
    FETCH_PRACTICE_INCOME_REQUEST,
    FETCH_PRACTICE_INCOME_SUCCESS,
    FETCH_PRACTICE_INCOME_FAILURE,
  } from "./FetchPracticeIncomeTypes";
  
  const initialState = {
    loading: false,
    practiceIncome: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PRACTICE_INCOME_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PRACTICE_INCOME_SUCCESS:
        return {
          loading: false,
          practiceIncome: action.payload,
          error: "",
        };
      case FETCH_PRACTICE_INCOME_FAILURE:
        return {
          loading: false,
          practiceIncome: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  